/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'rotate-ccw': {
    width: 16,
    height: 16,
    viewBox: '0 0 20.298 20.298',
    data: '<path pid="0" d="M.952 11.102c0-.264.213-.474.475-.474h2.421c.262 0 .475.21.475.474 0 3.211 2.615 5.826 5.827 5.826s5.827-2.615 5.827-5.826a5.832 5.832 0 0 0-6.843-5.737v1.647a.475.475 0 0 1-.812.335L3.49 4.074a.472.472 0 0 1 0-.667L8.323.139a.479.479 0 0 1 .519-.104.476.476 0 0 1 .291.438V1.96c.34-.038.68-.057 1.016-.057 5.071 0 9.198 4.127 9.198 9.198 0 5.07-4.127 9.197-9.198 9.197-5.07.001-9.197-4.126-9.197-9.196z" _fill="#030104"/>'
  }
})
